export default __webpack_public_path__ + "static/media/LPLCM.67971fbd.png";